export default __webpack_public_path__ + "static/media/intro_sh_logo@2x.00e0c73b.png";